import { Row, Col } from 'react-bootstrap';
import { useState } from 'react';

export default function Project({ completed = false, title, description = "No description provided." }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div style={{ paddingLeft: "1rem" }}>
      <Row className="level-header" onClick={toggleExpand}>
        <Col xs={12}>
          <p style={{ fontSize: '.8rem', fontStyle: 'italic' }}>

            {completed
              ?
              <i className="bi bi-check-circle" style={{ fontSize: '1rem', color: '#00A261' }}></i>
              :
              <i className="bi bi-circle" style={{ fontSize: '1rem', color: '#00A261' }}></i>
            }

            &nbsp;{title}
          </p>
        </Col>
      </Row>
      {isExpanded && (
        <Row className="level-details">
          <Col>
            {/* Additional details can be added here */}
            <h4>About the {title}</h4>
            <p>{description}</p>
          </Col>
        </Row>
      )}
    </div>
  );
}